module.exports = __webpack_public_path__ + "static/media/light-switch-off.0f6b003b.svg";